import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { APIRoutes } from '../global-misc/api-routes';
import { OrgInvite, CreateOrgInviteDto, UpdateOrgInviteDto } from '../global-data-models/org-invite.model';

@Injectable({ providedIn: 'root' })
export class OrgInvitesService {
  constructor(private http: HttpClient) {}

  async createInvite(orgId: string, dto: CreateOrgInviteDto): Promise<OrgInvite> {
    const url = APIRoutes.ORG_INVITES_ROUTE.replace(':orgId', orgId);
    return firstValueFrom(this.http.post<OrgInvite>(url, dto));
  }

  async findAllInvitesForOrg(orgId: string): Promise<OrgInvite[]> {
    const url = APIRoutes.ORG_INVITES_ROUTE.replace(':orgId', orgId);
    return firstValueFrom(this.http.get<OrgInvite[]>(url));
  }

  async findOneInvite(orgId: string, inviteId: string): Promise<OrgInvite> {
    const url = APIRoutes.SINGLE_ORG_INVITE_ROUTE.replace(':orgId', orgId).replace(':inviteId', inviteId);
    return firstValueFrom(this.http.get<OrgInvite>(url));
  }


  async updateInvite(orgId: string, inviteId: string, dto: UpdateOrgInviteDto): Promise<OrgInvite> {
    const url = APIRoutes.SINGLE_ORG_INVITE_ROUTE.replace(':orgId', orgId).replace(':inviteId', inviteId);
    return firstValueFrom(this.http.patch<OrgInvite>(url, dto));
  }

  async resendInvite(orgId: string, inviteId: string): Promise<OrgInvite> {
    // Assuming resend is a POST to a specific sub-resource as per my api-routes.ts addition
    // If the backend implements resend differently (e.g., a PATCH with a specific body), this needs adjustment.
    const url = APIRoutes.RESEND_ORG_INVITE_ROUTE.replace(':orgId', orgId).replace(':inviteId', inviteId);
    return firstValueFrom(this.http.post<OrgInvite>(url, {})); // Assuming resend takes no body or a specific one
  }

  async deleteInvite(orgId: string, inviteId: string): Promise<void> {
    const url = APIRoutes.SINGLE_ORG_INVITE_ROUTE.replace(':orgId', orgId).replace(':inviteId', inviteId);
    return firstValueFrom(this.http.delete<void>(url));
  }

  // Revoke might be conceptually similar to delete, or it might be an update to a 'status' field.
  // Given the controller, DELETE seems the most straightforward for "revoke".
  async revokeInvite(orgId: string, inviteId: string): Promise<void> {
    return this.deleteInvite(orgId, inviteId);
  }
}
